import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(VueRouter);

const router: any = new VueRouter({
  mode: "history",
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

router.beforeEach((to: SquareConfig, from: SquareConfig, next: () => void) => {
  NProgress.start();
  if (to.meta.title) document.title = to.meta.title;
  next();
});

router.afterEach(() => {
  // eslint-disable-next-line
  // typeof gio === "function" && gio("send");
  NProgress.done();
});

export default router;
